import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import { v1 as uuidv1 } from 'uuid';
import CryptoJS from 'crypto-js';
import { getApiUrl } from './env';
import { Modal } from 'antd';
import { delToken, logout, closeWindow } from '../hooks';
import { getLogout } from '../services/system';
let socket;
let stompClient;
let socketConnectStatus = 'close'; // webscoket连接情况
let sesseionId; // 为了跟加签的数据保持一致
let serverPort = '8000'; // 为了跟加签的数据保持一致
let timerOutCtx = null;
const startIntervalMap = [30000, 60000, 300000, 600000];
// 失败重连的时间索引
let startIntervalIndex = -1;
let subscribeObj = {};
const storePtValue = sessionStorage.getItem('pt') || 1;
// 共有的消息接收
async function onMessageCommon(data, config) {
    if (data.type == 'all' &&
        data.data &&
        ['logout', 'logoutSelf'].includes(data.data.msgType)) {
        // 收到退出的通知
        // console.log('收到退出的通知');
        const uid = sessionStorage.getItem('USER_INFO');
        const userInfo = JSON.parse(uid);
        const fp = localStorage.getItem('fp');
        const pt = sessionStorage.getItem('pt');
        console.log({ logout: data });
        // 删除本地缓存
        if (data.data.msgType == 'logout') {
            delToken();
            closeSocket();
            const par = {
                id: userInfo.id,
                fp
            };
            await getLogout(par);
            if (window.opener && window.opener != null) {
                closeWindow();
            }
            else {
                Modal.warning({
                    title: '提示',
                    content: data?.data?.data,
                    okText: '确定',
                    onOk: () => {
                        logout(2, userInfo.id);
                    },
                });
            }
        }
        else {
            // console.log(data?.data?.data);
            const dataJSON = JSON.parse(data?.data?.data);
            // 主动退出 type: 登出类型，1: 登录登出，2: 修改密码登出， 3：切换企业
            if (dataJSON?.type == 2) {
                if (window.opener && window.opener != null) {
                    closeWindow();
                }
                else {
                    Modal.warning({
                        title: '提示',
                        content: dataJSON?.message,
                        okText: '确定',
                        onOk: () => {
                            logout(2, userInfo.id);
                        },
                    });
                }
            }
            else {
                if (dataJSON?.fp == fp && dataJSON?.pt == pt) {
                    closeWindow(dataJSON?.type);
                    // 切换企业不登出
                    if (dataJSON?.type !== 3) {
                        logout(1, data.data.userId);
                    }
                }
            }
        }
    }
    else if (config?.receiveMessage) {
        config.receiveMessage({ subUrl: data.subUrl }, data.data);
    }
}
function initSocket(self, sub, mainConfig) {
    if (!sessionStorage.getItem('USER_INFO')) {
        return;
    }
    if (socketConnectStatus == 'connecting') {
        return;
    }
    socketConnectStatus = 'connecting';
    // 存在已连接的，先关闭
    subscribeObj = {};
    closeSocket();
    sesseionId = uuidv1();
    const uid = sessionStorage.getItem('USER_INFO');
    const userInfo = JSON.parse(uid);
    const baseUrl = mainConfig?.apiUrl ?? getApiUrl() ?? window.location.origin;
    const socketUrl = urlEncryption(userInfo.id, self?.socketParams);
    if (!socketUrl) {
        return;
    }
    socket = new SockJS(`${baseUrl}${socketUrl}`, null, {
        server: serverPort,
        sessionId: sessionId,
    });
    // 获取STOMP子协议的客户端对象
    stompClient = Stomp.over(socket);
    stompClient.heartbeat.outgoing = 20000; // client will send heartbeats every 20000ms
    stompClient.heartbeat.incoming = 20000; // client does not want to receive heartbeats from the server
    // 定义客户端的认证信息,按需求配置
    const ptValue = self?.socketParams?.pt || storePtValue;
    const headers = {
        'user-name': `${userInfo.id}_${ptValue}`,
    };
    // 拦截输出的一大堆信息
    stompClient.debug = function (str) {
        // console.log(str)
    };
    // 失败重连时间，3000毫秒
    stompClient.reconnectDelay = 3000;
    // 向服务器发起websocket连接
    stompClient.connect(headers, () => {
        // console.log(frame) frame: any
        socketConnectStatus = 'success';
        // 成功回调
        self?.receiveMessage?.({ socketConnectStatus }, {
            target: socket,
        });
        // 初始化失败重连的时间索引
        startIntervalIndex = -1;
        // 退出登录消息订阅
        let logoutSub = [
            `/wstopic/push/${ptValue}/${userInfo.id}/${localStorage.getItem('fp')}/kickout`,
            `/wstopic/push/${userInfo.id}/logout`,
        ];
        if (sub && sub.length > 0) {
            logoutSub = logoutSub.concat(sub);
        }
        socketSubscribe(self, logoutSub);
    }, () => {
        // console.log(err)
        // 连接发生错误时的处理函数
        socketConnectStatus = 'failed';
        console.log('webSocket连接失败11111: 重连时间：', startIntervalMap[startIntervalIndex]);
        closeSocket();
        reconnectSocket(self, sub, mainConfig);
    });
}
function closeSocket() {
    subscribeObj = {};
    socketConnectStatus = 'close';
    if (stompClient) {
        stompClient.disconnect();
    }
    if (socket) {
        socket.close();
    }
}
/**
 *
 * @param self {
 * receiveMessage：消息回调事件
 * uniqueKey: 订阅唯一标识符号；为了区分两次相同的订阅
 * }
 * @param sub 订阅集合
 * @returns
 */
function socketSubscribe(self, sub) {
    if (socketConnectStatus != 'success') {
        return;
    }
    for (let i = 0; i < sub.length; i++) {
        const subKey = sub[i];
        const uid = sessionStorage.getItem('USER_INFO');
        const userInfo = JSON.parse(uid);
        const fpVal = localStorage.getItem('fp');
        subscribeObj[subKey + (self?.uniqueKey || '')] = stompClient.subscribe(subKey, (response) => {
            if (response.body) {
                // console.log(userInfo)
                const ptValue = self?.socketParams?.pt || storePtValue;
                const logoutSub = `/wstopic/push/${ptValue}/${userInfo.id}/${fpVal}/kickout`;
                const logoutActive = `/wstopic/push/${userInfo.id}/logout`;
                const resData = { subUrl: subKey, data: response.body };
                // 退出登录的提示
                if (logoutSub == subKey) {
                    resData.type = 'all';
                    resData.data = {
                        msgType: 'logout',
                        data: response.body,
                    };
                }
                else if (logoutActive == subKey) {
                    resData.type = 'all';
                    resData.data = {
                        msgType: 'logoutSelf',
                        userId: userInfo.id,
                        data: response.body,
                    };
                }
                onMessageCommon(resData, self);
            }
        });
    }
}
function socketCloseSubscribe(sub, data) {
    const uniqueKey = data?.uniqueKey || '';
    if (stompClient && sub) {
        sub.forEach((item) => {
            if (subscribeObj[item + uniqueKey]) {
                subscribeObj[item + uniqueKey].unsubscribe();
            }
        });
    }
}
// 重连socket
function reconnectSocket(self, sub, mainConfig) {
    if (timerOutCtx) {
        clearTimeout(timerOutCtx);
        timerOutCtx = null;
    }
    if (startIntervalIndex >= startIntervalMap.length - 1) {
        startIntervalIndex = 0;
    }
    else {
        startIntervalIndex += 1;
    }
    if (startIntervalIndex > -1) {
        timerOutCtx = setTimeout(() => {
            initSocket(self, sub, mainConfig);
        }, startIntervalMap[startIntervalIndex]);
    }
}
function sendMessage(topic, message) {
    stompClient.send(topic, {}, message);
}
// 加密
function urlEncryption(userId, otherParams) {
    let appId = '55cHKgNTOJWhODaJ1m9678'; //应用id
    let appSecret = 'gNTOJWhODaJ1m9678PD0LWHK2KTic'; //应用密钥
    const d = new Date();
    const time = d.getTime();
    const nonce = uuidv1();
    // socket的连接地址
    const socketUrl = `/openapi/messageopen/wsendpoint`;
    // let socketParams = `?userId=${userId}&type=pc`;
    const socketParams = [
        `userId=${userId}`,
        'type=pc',
        `_r=${nonce}`,
        `_t=${time}`,
    ];
    let havePtFlag = false;
    if (otherParams) {
        const keys = Object.keys(otherParams);
        if (keys?.length > 0) {
            keys.forEach((itemKey) => {
                if (itemKey == 'pt') {
                    havePtFlag = true;
                }
                socketParams.push(`${itemKey}=${otherParams[itemKey]}`);
            });
        }
    }
    if (!havePtFlag) {
        // 默认拼上pt
        socketParams.push(`pt=${storePtValue}`);
    }
    //参数排序
    socketParams.sort();
    // 构造指定的sockjs-client组件自带的地址
    const stompUrl = `/${serverPort}/${sesseionId}/websocket`;
    //签名串拼接
    const stringToSign = `GET\n{}\n\n${time}\nx-wisdaas-request-id:${nonce}\n${socketUrl}${stompUrl}?${socketParams.join('&')}`;
    const hash = CryptoJS.HmacSHA256(stringToSign, appSecret);
    const b64 = CryptoJS.enc.Base64.stringify(hash);
    const sign = 'WISDAAS-V2 ' + appId + ':' + b64;
    // 参数date、nonce必传,query参数后_t、_r
    //将sign加到query参数:_s,必段加到最后一个参数,必须先编码
    let s = encodeURIComponent(sign);
    socketParams.push(`_s=${s}`);
    return `${socketUrl}?${socketParams.join('&')}`;
}
function sessionId() {
    return sesseionId;
}
export default {
    webSocket: socket,
    initSocket: initSocket,
    closeSocket: closeSocket,
    socketSubscribe: socketSubscribe,
    socketCloseSubscribe: socketCloseSubscribe,
    sendMessage: sendMessage,
};
